// mirrors server/src/shared/config/lead-score-levels.ts leadScoreLevelsFor
import { FarewillProduct, PRODUCTS } from 'utils/enums'

/** One lead score level: its number and what it means */
export type LeadScoreLevel = {
  level: number
  description: string
}

/** Numbers each description from 1, in the order given */
const levels = (...descriptions: string[]): LeadScoreLevel[] =>
  descriptions.map((description, index) => ({
    level: index + 1,
    description,
  }))

/** Wills, LPAs and funerals: how far along the quote is */
const QUOTE_LEVELS = levels(
  "They're happy with our quote",
  "They need to check we're right for them",
  'We still need to provide the quote'
)

/** Every product's lead score levels, 1 being the most likely to convert */
const LEAD_SCORE_LEVELS: Record<FarewillProduct, LeadScoreLevel[]> = {
  /** How far along the customer is (ADR 0003, "Levels") */
  [PRODUCTS.FUNERAL_PLAN]: levels(
    "They've told us they're going ahead",
    'Considering our quote, callback booked',
    'Considering our quote, no callback yet',
    "We've posted them a brochure",
    "We've emailed them a brochure",
    "We've spoken to them, nothing sent yet",
    "We haven't spoken to them yet"
  ),
  [PRODUCTS.WILL]: QUOTE_LEVELS,
  [PRODUCTS.LPA]: QUOTE_LEVELS,
  [PRODUCTS.FUNERAL]: QUOTE_LEVELS,
  /** Worked out automatically on the server */
  [PRODUCTS.PROBATE]: levels(
    'Executor, complex',
    'Not executor, complex',
    'Executor, simple',
    'Not executor, simple',
    'Other'
  ),
}

/** The lead score levels a lead's product uses, in order from 1 */
export const leadScoreLevelsFor = (
  product: FarewillProduct
): LeadScoreLevel[] => LEAD_SCORE_LEVELS[product]
